import { Component, OnInit } from '@angular/core';
import { FormBuilder,Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Utility } from '../../../../../../Autofacets-Core/src/app/utils/utility';
import { TranslateService } from '@ngx-translate/core';
import { RolesRightsService } from '../../../business-services/roles-rights.service';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicationMasterModel } from '../../../business-entities/application-master-model';

@Component({
  selector: 'app-add-roles-rights',
  templateUrl: './add-roles-rights.component.html'
})
export class AddRolesRightsComponent implements OnInit {
  addRoleForm: FormGroup = new FormGroup({});
  applicationMasterList: ApplicationMasterModel[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private activeModal : NgbActiveModal,
    private translate : TranslateService,
    private rolesRightsService: RolesRightsService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.addRoleForm = this.formBuilder.group({
      roleName: ['',[Validators.required]],
      priority: [null,[Validators.required]],
      applicationCode:[null,[Validators.required]]
    });
    this.GetApplicationList();
  }

  OnClose(){
    this.activeModal.close({success:false})
  }

  get cpf() {
    return this.addRoleForm.controls;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  async GetApplicationList(): Promise<void> {
    await this.rolesRightsService.GetApplicationList().then(data => {
      this.applicationMasterList = this.ApplicationDataMapper(data.responseObject)
    })
  }

  private ApplicationDataMapper(application: any) {
    let supperArray = [];
    if (application && application.length > 0) {

      for (const element of application) {
        let single = {
          id: element.id,
          applicationName: element.applicationName,
          applicationCode: element.applicationCode,
          isActive: element.isActive
        };
  
        if (single.isActive)
          supperArray.push(single);
      }
    }
    return supperArray;
  }

  AddRole() {
    if (this.addRoleForm.invalid) {
      return;
    }
    let successMessage = this.translate.instant("lblRoleAddedSuccessfully");
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue")

    let viewModel = {
      roleName: this.addRoleForm.value.roleName,
      priority: +this.addRoleForm.value.priority,
      applicationCode:this.addRoleForm.value.applicationCode,
    }

      this.rolesRightsService.AddRole(viewModel).then(res => {
        if(res.responseCode === Constant.SuccessResponseCode)
        {
          if (res?.responseObject?.result?.isSuccess) {
            this.activeModal.close({ success: true });
            this.toaster.success(successMessage);
          } else {
            if(res?.responseObject?.result?.retValue == '-1'){
              let errormsg = this.translate.instant("lblRoleAlreadyAdded");
              this.toaster.error(errormsg);
            }else{
              let errormsg = this.translate.instant("lblInternalError");
              this.toaster.error(errormsg);
            }
          }
        }
      }, error => {
            this.spinner.hide();
        if(error.status === Constant.BadRequest)
        {
          this.toaster.warning(WarningMessage);
        }
        else
        {
          this.toaster.error(errorMessage);
        }
      });
  }

}
